import React, { createContext, useContext, useState } from 'react';
import { useUsageTracking } from '@/hooks/useUsageTracking';

interface UsageContextType {
  usageData: {
    count: number;
    canAsk: boolean;
    tier: string;
    limit: number | null;
    remaining: number | null;
    hoursSaved?: number;
    dollarsSaved?: number;
    lastUpdated?: number;
  };
  loading: boolean;
  checkUsage: () => Promise<any>;
  trackUsage: (complexity?: 'simple' | 'complex') => Promise<any>;
  showLimitDialog: boolean;
  setShowLimitDialog: (show: boolean) => void;
}

const UsageContext = createContext<UsageContextType | undefined>(undefined);

export const useUsage = () => {
  const context = useContext(UsageContext);
  if (context === undefined) {
    throw new Error('useUsage must be used within a UsageProvider');
  }
  return context;
};

export const UsageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { usageData, loading, checkUsage, trackUsage } = useUsageTracking();
  const [showLimitDialog, setShowLimitDialog] = useState(false);

  const value = {
    usageData,
    loading,
    checkUsage,
    trackUsage,
    showLimitDialog,
    setShowLimitDialog
  };

  return (
    <UsageContext.Provider value={value}>
      {children}
    </UsageContext.Provider>
  );
};